/**
 * en-GB messages added by Phase 3 task W20 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w20EnGB = {
    'nav.deliveries': 'Deliveries',
    'nav.signInPoints': 'Sign-in points',
    'nav.remoteSite': 'Remote site',
    'siteF.site': 'Site',
    'siteF.allSites': 'All sites',
    // Contactless card
    'siteF.contactless.title': 'Contactless sign-in',
    'siteF.contactless.description': 'Let visitors sign in with their own phone by scanning a code. No app is needed.',
    'siteF.contactless.enabled': 'Allow contactless sign-in at this site',
    'siteF.contactless.enabledHint': 'Off by default. Visitors who scan the code see a page that says contactless sign-in is not available.',
    'siteF.contactless.qrMode': 'Type of code',
    'siteF.contactless.mode.static': 'Printed code (the same code every time)',
    'siteF.contactless.mode.rotating': 'Rotating code (shown on the kiosk and changes every couple of minutes)',
    'siteF.contactless.perHour': 'Most sessions per hour',
    'siteF.contactless.perHourHint': 'Protects the site from a flood of scans. 0 means no limit.',
    'siteF.contactless.nearSite': 'Only allow sign-in near the site',
    'siteF.contactless.nearSiteHint': "Asks for the phone's location and refuses it if it is far from the site. The location is not stored.",
    'siteF.contactless.link': 'Printed link',
    'siteF.contactless.version': 'Link version {n}',
    'siteF.contactless.poster': 'Print poster',
    'siteF.contactless.copy': 'Copy link',
    'siteF.contactless.newLink': 'Make a new link',
    'siteF.contactless.newLinkConfirm': 'Yes, make a new link',
    'siteF.contactless.newLinkDone': 'A new link has been made. Print the poster again.',
    'siteF.contactless.newLinkWarning': 'A new link stops every printed code for this site working straight away.',
    'siteF.contactless.rotatingNote': 'This site uses a rotating code, which the kiosk shows on its screen. A rotating code changes every couple of minutes, so there is nothing to print. Switch to a printed code and save to print a poster.',
    // Capacity card
    'siteF.capacity.title': 'Capacity',
    'siteF.capacity.description': 'The safe number of people on site. The portal and the alerts use it to show how full the site is.',
    'siteF.capacity.capacity': 'Capacity (people)',
    'siteF.capacity.capacityHint': '0 means no capacity is set, so there are no levels and no alerts.',
    'siteF.capacity.amber': 'Amber from (% of capacity)',
    'siteF.capacity.red': 'Red from (% of capacity)',
    'siteF.capacity.levelsWrong': 'The red level must not be lower than the amber level.',
    'siteF.capacity.whenFull': 'When the site is full (red)',
    'siteF.capacity.whenFullHint': 'Staff and evacuations are never stopped.',
    'siteF.capacity.when.off': 'Do nothing',
    'siteF.capacity.when.warn': 'Warn and tell reception',
    'siteF.capacity.when.block_visitors': 'Stop new visitor sign-ins',
    'siteF.capacity.countAssumed': 'Count staff who only sign out',
    'siteF.capacity.countAssumedHint': 'Counts members who never sign in as on site for the day. The count is then marked as an estimate.',
    // Sign-in points
    'siteF.points.title': 'Sign-in points',
    'siteF.points.description': 'Codes you print and put up around a site. People scan them with the CloudSign app or their phone camera.',
    'siteF.points.add': 'Add a sign-in point',
    'siteF.points.new': 'New sign-in point',
    'siteF.points.edit': 'Edit sign-in point',
    'siteF.points.editFor': 'Edit {name}',
    'siteF.points.name': 'Name',
    'siteF.points.mode': 'What it does',
    'siteF.points.mode.in': 'Sign in',
    'siteF.points.mode.out': 'Sign out',
    'siteF.points.mode.both': 'Sign in or out',
    'siteF.points.groups': 'Groups',
    'siteF.points.allGroups': 'Every group shown at the site',
    'siteF.points.limitGroups': 'Only some groups can use this point',
    'siteF.points.limitGroupsHint': 'Leave this off to let every group shown at the site use it.',
    'siteF.points.active': 'Active',
    'siteF.points.inactive': 'Switched off',
    'siteF.points.activate': 'Switch on',
    'siteF.points.deactivate': 'Switch off',
    'siteF.points.poster': 'Print poster',
    'siteF.points.posterFor': 'Print poster for {name}',
    'siteF.points.newLink': 'New link',
    'siteF.points.newLinkConfirm': 'Yes, make a new link (the printed poster stops working)',
    // Remote site
    'siteF.remote.title': 'Remote site',
    'siteF.remote.description': 'A site for people working away from the office. Members of the groups you choose can sign in to it from the CloudSign app.',
    'siteF.remote.add': 'Add a remote site',
    'siteF.remote.new': 'New remote site',
    'siteF.remote.newHint': 'Nobody can sign in to a new remote site until you choose which groups may.',
    'siteF.remote.defaultName': 'Working remotely',
    'siteF.remote.name': 'Name',
    'siteF.remote.timeZone': 'Time zone',
    'siteF.remote.create': 'Create remote site',
    'siteF.remote.badge': 'Remote',
    'siteF.remote.empty': 'There is no remote site yet.',
    'siteF.remote.groups': 'Groups that can sign in here',
    'siteF.remote.groupsHint': 'Only members of the ticked groups can sign in to this site. Everyone else is refused.',
    'siteF.remote.noGroups': 'No groups are chosen yet, so nobody can sign in to this site.',
    'siteF.remote.saveGroups': 'Save groups',
    'siteF.remote.delete': 'Delete remote site',
    'siteF.remote.archive': 'Archive it instead',
    // Deliveries
    'siteF.deliveries.title': 'Deliveries',
    'siteF.deliveries.description': 'Parcels that arrive at reception, who they are for and whether they have been collected.',
    'siteF.deliveries.log': 'Log a parcel',
    'siteF.deliveries.logSubmit': 'Log parcel',
    'siteF.deliveries.memberGroup': 'Group of the person',
    'siteF.deliveries.memberSearch': 'Find the person',
    'siteF.deliveries.member': 'Person',
    'siteF.deliveries.noMember': 'Not on the list (type a name instead)',
    'siteF.deliveries.recipientName': 'Name of the person it is for',
    'siteF.deliveries.recipientNameHint': 'Use this when the person is not on the list. They will not be told it has arrived.',
    'siteF.deliveries.carrier': 'Courier',
    'siteF.deliveries.parcels': 'Parcels',
    'siteF.deliveries.location': 'Kept at',
    'siteF.deliveries.locationHint': 'For example "Post room shelf B".',
    'siteF.deliveries.reference': 'Reference',
    'siteF.deliveries.notes': 'Notes',
    'siteF.deliveries.photo': 'Photo of the parcel',
    'siteF.deliveries.photoHint': 'A JPEG photo up to 1 MB. Optional.',
    'siteF.deliveries.notify': 'Tell the person it has arrived',
    'siteF.deliveries.col.logged': 'Logged',
    'siteF.deliveries.col.recipient': 'For',
    'siteF.deliveries.status.waiting': 'Waiting',
    'siteF.deliveries.status.collected': 'Collected',
    'siteF.deliveries.status.returned': 'Returned',
    'siteF.deliveries.status.cancelled': 'Cancelled',
    'siteF.deliveries.collectedLine': 'Collected by {name}, {when}',
    'siteF.deliveries.reminders': '{n} reminders sent',
    'siteF.deliveries.collect': 'Collected',
    'siteF.deliveries.collectFor': 'Mark the parcel for {name} as collected',
    'siteF.deliveries.collectedBy': 'Collected by',
    'siteF.deliveries.collectSubmit': 'Record collection',
    'siteF.deliveries.signature': 'Signature (needed at this site)',
    'siteF.deliveries.signatureOptional': 'Signature (optional)',
    'siteF.deliveries.signatureNote': 'This site asks for a signature when a parcel is collected.',
    'siteF.deliveries.return': 'Returned',
    'siteF.deliveries.returnFor': 'Mark the parcel for {name} as returned to the courier',
    'siteF.deliveries.notifyAgain': 'Tell them again',
    'siteF.deliveries.notified': 'They have been told again.',
    'siteF.deliveries.cancel': 'Cancel parcel',
    // Events
    'siteF.events.title': 'Events',
    'siteF.events.description': 'Open days, courses and other events, with who is expected and who has arrived.',
    'siteF.events.add': 'Add an event',
    'siteF.events.new': 'New event',
    'siteF.events.edit': 'Edit event',
    'siteF.events.name': 'Name',
    'siteF.events.descriptionField': 'Description',
    'siteF.events.startsAt': 'Starts',
    'siteF.events.endsAt': 'Ends',
    'siteF.events.zoneHint': 'Time in {zone}',
    'siteF.events.capacity': 'Capacity (optional)',
    'siteF.events.capacityHint': 'Only a warning on this page. It does not stop anyone signing in.',
    'siteF.events.groups': 'Groups',
    'siteF.events.groupsHint': 'People who sign in to these groups at the site during the event count as attending.',
    'siteF.events.when': 'Show',
    'siteF.events.when.upcoming': 'Upcoming events',
    'siteF.events.when.past': 'Past events',
    'siteF.events.when.all': 'All events',
    'siteF.events.status.draft': 'Draft',
    'siteF.events.status.published': 'Published',
    'siteF.events.status.cancelled': 'Cancelled',
    'siteF.events.attendance': 'Attendance',
    'siteF.events.countsLine': '{arrived} of {expected} arrived, {walkIns} walk-ins',
    'siteF.events.details': 'Details',
    'siteF.events.dates': '{site}, {start} to {end}',
    'siteF.events.publish': 'Publish',
    'siteF.events.cancelEvent': 'Cancel event',
    'siteF.events.delete': 'Delete event',
    'siteF.events.arrivedOf': '{arrived} of {expected}',
    'siteF.events.walkInsLine': '{n} walk-ins',
    'siteF.events.capacityLine': 'Capacity {n}',
    'siteF.events.overCapacity': 'More people are expected than the capacity.',
    'siteF.events.attendees': 'Attendees',
    'siteF.events.attendeesHint': 'People expected at the event, and walk-ins who signed in during it. Past events keep their list.',
    'siteF.events.attendee.name': 'Name',
    'siteF.events.attendee.email': 'Email',
    'siteF.events.attendee.company': 'Company',
    'siteF.events.attendee.add': 'Add a person',
    'siteF.events.attendee.remove': 'Remove',
    'siteF.events.attendee.walkIn': 'Walk-in',
    'siteF.events.attendee.setStatus': 'Status of {name}',
    'siteF.events.attendee.status.expected': 'Expected',
    'siteF.events.attendee.status.arrived': 'Arrived',
    'siteF.events.attendee.status.no_show': 'Did not come',
    'siteF.events.attendee.status.cancelled': 'Cancelled',
    'siteF.events.bulk.open': 'Add a list',
    'siteF.events.bulk.hint': 'One person per line: name, email, company. The email and company are optional. You can paste from a spreadsheet or choose a CSV file.',
    'siteF.events.bulk.file': 'CSV file',
    'siteF.events.bulk.paste': 'Or paste the list here',
    'siteF.events.bulk.preRegister': 'Also pre-register them',
    'siteF.events.bulk.preRegisterHint': 'Creates a pre-registration for each person, expected at the start of the event.',
    'siteF.events.bulk.found': '{n} people found.',
    'siteF.events.bulk.rejected': 'These lines were skipped because they have no name or the email is not valid: {lines}.',
    'siteF.events.bulk.submit': 'Add the list',
    'siteF.events.bulk.done': '{added} added, {skipped} already on the list, {pre} pre-registered.',
    // Occupancy
    'siteF.occupancy.title': 'Live occupancy',
    'siteF.occupancy.description': 'How many people are on each site now. Counts only, no names.',
    'siteF.occupancy.empty': 'There are no sites to show.',
    'siteF.occupancy.onSite': 'People on site',
    'siteF.occupancy.percent': '{n}% of capacity',
    'siteF.occupancy.noCapacity': 'No capacity is set for this site.',
    'siteF.occupancy.estimated': 'Estimate: includes {n} people assumed to be on site.',
    'siteF.occupancy.byGroup': 'By group',
    'siteF.occupancy.seeToday': 'See who is in',
    'siteF.occupancy.history': 'History',
    'siteF.occupancy.historyHint': 'How busy the site has been. The dashed line is the capacity.',
    'siteF.occupancy.range': 'Period',
    'siteF.occupancy.range.1': 'Last 24 hours',
    'siteF.occupancy.range.7': 'Last 7 days',
    'siteF.occupancy.range.30': 'Last 30 days',
    'siteF.occupancy.capacityLine': 'Capacity {n}',
};
//# sourceMappingURL=w20.js.map